import { JSX } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { LeftNavigation, LeftNavigationProps } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

interface N03LeftSideNavigationProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: LeftNavigationProps;
}

export const Default = (props?: N03LeftSideNavigationProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return props?.fields?.navigations ? (
    <LeftNavigation
      data-elastic-exclude=""
      data-component={marketingRenderingName}
      navigations={props.fields.navigations}
    />
  ) : (
    <></>
  );
};
